import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { LANGUAGES } from 'src/app/constants/lang';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.scss'],
  standalone: false
})
export class EventDetailsComponent implements OnInit {
  userLanguage: string;
  public languages = LANGUAGES;
  constructor(
    private translate: TranslateService,
    public auth: UserService,
    public dialogRef: MatDialogRef<EventDetailsComponent>,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.userLanguage = this.userService.lang;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.userLanguage = event.lang;
    });
  }

  close() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close(true);
  }
}
